<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Pancreas Specific Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="pancreasType"
              disabled
              label="PAK"
              :class="{ highlightField: isDifferent(pancreasType, pancreasTypeOATS) }"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="pancreasTypeOATS"
              disabled
              label="PAK"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="diabetesTypeCode"
              disabled
              label="Diabetes Type Code"
              :class="{ highlightField: isDifferent(diabetesTypeCode, diabetesTypeCodeOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="diabetesTypeCodeOATS"
              disabled
              label="Diabetes Type Code"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="comments"
              disabled
              label="Comments"
              :class="{ highlightField: isDifferent(comments, generalCommentsOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="generalCommentsOATS"
              disabled
              label="Comments"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "PancreasSpecificSectionDetailsEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      pancreasType: this.getPancreasType( this.patientBundle ),
      diabetesTypeCode: this.getDiabetesTypeCode( this.patientBundle ),
      pancreasTypeOATS: this.getPancreasTypeOATS( this.patientBundleOATS ),
      diabetesTypeCodeOATS: this.getDiabetesTypeCodeOATS( this.patientBundleOATS ),
      comments: this.getComments( this.patientBundle ),
      generalCommentsOATS: this.getGeneralCommentsOATS( this.patientBundleOATS ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getPancreasType( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8198', 'valueBoolean' ) == null || this.getSmartdataComponentValue( patientBundle, 'SK#8198', 'valueBoolean' ) === '' ) 
      return 'Unchecked';
      return this.getSmartdataComponentValue( patientBundle, 'SK#8198', 'valueBoolean' ) === true ? 'Checked' : 'Unchecked';
    },
    getPancreasTypeOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 6 && ( n.state !== 'cancelled' && n.state !== 'declined' && n.completed === false ) ) ); 
      if( journey && journey[ 0 ] ) {
        if( journey[ 0 ].organ_specific_details?.pancreas_type == null || journey[ 0 ].organ_specific_details?.pancreas_type === '' ) 
        return '';
        return journey[ 0 ].organ_specific_details?.pancreas_type === 'PAK' ? 'Checked' : 'Unchecked';
      }
    },
    getDiabetesTypeCode( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8199' );
    },
    getDiabetesTypeCodeOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 6 && ( n.state !== 'cancelled' && n.state !== 'declined' && n.completed === false ) ) ); 
      if( journey && journey[ 0 ] ) {
        if( journey[ 0 ].organ_specific_details?.diabetes_type_code == null || journey[ 0 ].organ_specific_details?.diabetes_type_code === '' ) 
        return '';
        return journey[ 0 ].organ_specific_details?.diabetes_type_code === 1 ? 'Type 1' : 'Type 2';
      }
    },
    getComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8200' );
    },
    getGeneralCommentsOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 6 && n.state !== 'cancelled' && n.completed === false ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].comments;
      }
    },
    isDifferent( a, b ) {
      return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
  },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 400px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

.highlightField :deep(.afflo-ds-form-control) {
  border: 2px solid red;
}

</style>
